/* =========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'
import { messages } from './main'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login-session',
          component: () => import('@/views/pages/Login.vue')
        }
      ]
    },
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/co',
          name: 'co',
          component: () => import('./views/pages/Co/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'Co2', active: true }
            ],
            pageTitle: 'Devices'
          }
        },
        {
          path: '/co/detail/:uuid',
          name: 'co-detail',
          component: () => import('./views/pages/Co/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Co2', url: '/co' },
              { title: 'DeviceInfo', active: true }
            ],
            pageTitle: 'DeviceInfo'
          }
        },
        {
          path: '/co/config/:uuid',
          name: 'co-config',
          component: () => import('./views/pages/Co/Config.vue'),
          meta: {
            breadcrumb: [
              { title: 'Co2', url: '/co' },
              { title: 'DeviceConfig', active: true }
            ],
            pageTitle: 'DeviceConfig',
            rule: 'admin'
          }
        },
        {
          path: '/co/statistics/:uuid',
          name: 'co-statistics',
          component: () => import('./views/pages/Co/Statistics.vue'),
          meta: {
            breadcrumb: [
              { title: 'Co2', url: '/co' },
              { title: 'Statistics', active: true }
            ],
            pageTitle: 'Statistics'
          }
        },
        {
          path: '/map',
          name: 'map',
          component: () => import('./views/pages/Map.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/map' }],
            pageTitle: 'GeneralMap'
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/pages/Dashboard.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/dashboard' }],
            pageTitle: 'Dashboard'
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/pages/Profile.vue'),
          meta: {
            breadcrumb: [{ title: 'Profile', url: '/profile' }],
            pageTitle: 'Profile'
          }
        }

      ]
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (store.state.AppActiveUser.token.length > 0) {
    if (to.path === '/' || to.path === '/forgot-password' || (store.state.AppActiveUser.userRole !== 'MA' && to.matched.some(record => record.meta.rule === 'admin'))) {
      window.location.href = '/co'
    } else {
      messages().then(() => next())
    }
  } else if (to.path === '/' || to.path === '/forgot-password') {
    messages().then(() => next())
  } else {
    window.location.href = '/'
  }
})

export default router
